import { useState, useEffect } from "react";
import theme from "../data/theme";

export default function OnboardingSheet({ storageKey, section, headline, subtitle }) {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(storageKey) === "true"; } catch { return false; }
  });
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    const t = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(t);
  }, [dismissed]);

  if (dismissed) return null;

  const handleDismiss = () => {
    setClosing(true);
    setTimeout(() => setDismissed(true), 250);
  };

  const handleDontShow = () => {
    try { localStorage.setItem(storageKey, "true"); } catch { /* ignore */ }
    handleDismiss();
  };

  const show = visible && !closing;

  return (
    <div
      onClick={handleDismiss}
      style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1100,
        display: "flex", alignItems: "center", justifyContent: "center",
        background: show ? theme.helpers.overlay(0.7) : theme.helpers.overlay(0),
        transition: "background 0.25s ease-out",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: theme.colors.bg.raised,
          border: `1px solid ${theme.colors.border.brand}`,
          borderRadius: 14,
          padding: "24px 28px",
          maxWidth: 380,
          width: "88vw",
          // 🔴 A LONG SUBTITLE WRAPS, IT NEVER TRUNCATES, and on a short screen
          // it scrolls rather than running off the bottom of a centred card
          // with no way to reach the buttons. Inert for every sheet that fits.
          maxHeight: "86vh",
          overflowY: "auto",
          boxShadow: `0 16px 48px ${theme.helpers.overlay(0.8)}`,
          transform: show ? "scale(1)" : "scale(0.95)",
          opacity: show ? 1 : 0,
          transition: "transform 0.25s ease-out, opacity 0.25s ease-out",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 11, fontWeight: 700, color: theme.colors.brand.orange, fontFamily: theme.fonts.display, letterSpacing: "1.5px", textTransform: "uppercase" }}>
          {section}
        </div>
        <div style={{ fontSize: 16, fontWeight: 700, color: theme.colors.text.primary, fontFamily: theme.fonts.display, marginTop: 8, lineHeight: 1.4 }}>
          {headline}
        </div>
        {/* 🔴 A STRING OR A LIST, AND THE SAME INK EITHER WAY. Four sentences
            of centred prose is a paragraph nobody finishes; as four bullets it
            is four things you can each decide to read. Callers that pass a
            string render exactly what they always did, down to the element.

            🔴 THE LIST ALIGNS LEFT while the card stays centred. Centred
            bullets put every marker at a different x and leave a wrapped line
            hanging under nothing, which is the one layout that reads worse than
            the paragraph this replaces. */}
        {Array.isArray(subtitle) ? (
          <ul style={{
            fontSize: 13, color: theme.colors.text.secondary, marginTop: 6, marginBottom: 0,
            lineHeight: 1.4, textAlign: "left", paddingLeft: 20,
          }}>
            {subtitle.map((line, i) => (
              // Spaced with a margin rather than a flex gap: flex blockifies
              // its children, which takes the list markers away with it.
              <li key={i} style={{ marginBottom: i === subtitle.length - 1 ? 0 : 4 }}>{line}</li>
            ))}
          </ul>
        ) : (
          <div style={{ fontSize: 13, color: theme.colors.text.secondary, marginTop: 6, lineHeight: 1.4 }}>
            {subtitle}
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, marginTop: 20 }}>
          <button
            onClick={handleDismiss}
            style={{
              background: theme.colors.brand.gradientBtn, border: "none", color: "#fff",
              fontSize: 14, fontWeight: 700, fontFamily: theme.fonts.display, cursor: "pointer",
              padding: "10px 32px", borderRadius: 8, letterSpacing: "0.3px",
              WebkitTapHighlightColor: "transparent",
            }}
          >
            Got it
          </button>
          <span
            onClick={(e) => { e.stopPropagation(); handleDontShow(); }}
            style={{ fontSize: 11, color: theme.colors.text.secondary, fontWeight: 500, cursor: "pointer", WebkitTapHighlightColor: "transparent" }}
          >
            Don't show again
          </span>
        </div>
      </div>
    </div>
  );
}
